import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySum',
})
export class ArraySumPipe implements PipeTransform {
  transform(array: number[]): number {
    if (array && array.length > 0) {
      return array.reduce((total, arrayElement) => total + arrayElement, 0);
    } else {
      return 0;
    }
  }
}
